<script>
import Loading from '@/components/Loading.vue'
import SkeletonCardList from '@/components/SkeletonCardList.vue'
import auth from '@/utils/auth'
import http from '@/utils/http'

export default {
  name: 'EtaIndex',
  components: { Loading, SkeletonCardList },
  data: () => {
    return {
      localId: null,
      etas: null,
      active: false,
      etaToDelete: null,
    }
  },
  computed: {
    isAdmin() {
      return auth.isAdmin()
    },
  },
  async beforeMount() {
    this.localId = this.$route.params.localId

    await this.searchEtas()

    if (!this.isAdmin && this.etas.length === 1) {
      this.$router.push({
        name: 'EtaVisualizar',
        params: {
          localId: this.localId,
          etaId: this.etas[0].id,
        },
      })
    }
  },
  methods: {
    async searchEtas() {
      this.etas = null

      this.etas = await http.eta.get('local/' + this.localId + '/eta')
    },
    async deletarEta() {
      await http.eta
        .delete('eta/' + this.etaToDelete.id, this.etaToDelete.id)
        .then(() => {
          this.searchEtas()
          this.active = false
        })
        .catch(() => {
          this.active = false
        })
    },
  },
}
</script>

<template>
  <div>
    <Loading :loading="etas === null" />

    <md-table v-if="etas !== null">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">ETAS</h1>
        </div>
        <div v-if="isAdmin" class="md-toolbar-section-end">
          <router-link
            v-if="isAdmin"
            :to="{
              name: 'EtaCriar',
              params: { localId: $route.params.localId },
            }"
          >
            <md-button class="md-primary md-raised">
              <md-icon class="fa fa-bars"> add </md-icon>
              Nova ETA
            </md-button>
          </router-link>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Nome</md-table-head>
        <md-table-head>Nome captação</md-table-head>
        <md-table-head>Ações</md-table-head>
      </md-table-row>
      <md-table-row v-for="eta in etas" :key="eta.id" class="pt-2 pb-2">
        <md-table-cell>{{ eta.nome }}</md-table-cell>
        <md-table-cell>{{ eta.nomeCaptacao }}</md-table-cell>
        <md-table-cell>
          <router-link
            :to="{
              name: 'EtaVisualizar',
              params: {
                ...$route.params,
                etaId: eta.id,
              },
            }"
          >
            <md-button class="md-raised md-primary"> Visualizar </md-button>
          </router-link>

          <router-link
            :to="{
              name: 'EtaEditar',
              params: {
                ...$route.params,
                etaId: eta.id,
              },
            }"
          >
            <md-button class="md-raised md-primary"> Editar </md-button>
          </router-link>
          <md-button
            class="md-raised md-accent"
            @click="
              active = true
              etaToDelete = eta
            "
          >
            Deletar
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm
      :md-active.sync="active"
      md-title="Deletar ETA"
      md-content="Deseja realmente deletar esta ETA?"
      md-confirm-text="Deletar"
      md-cancel-text="Cancelar"
      @md-cancel="active = false"
      @md-confirm="() => deletarEta()"
    />
  </div>
</template>

<style scoped lang="scss"></style>
